import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { initializeDataverseService } from './services/dataverseService';
import { ThemeModeProvider } from './theme/ThemeModeContext';
import { isPortalMode } from './config/environment';
import { syncSelectedCustomerFromUrl, ensureCustomerSelection } from './lib/selectedCustomer';
import PortalApp from './PortalApp';
import CustomerApp from './CustomerApp';
import './styles/opencare-theme.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

function renderBootstrapLoading() {
  root.render(
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#0e2841'
      }}
    >
      Starter OpenCare…
    </div>
  );
}

function renderPortalApp() {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeModeProvider>
          <PortalApp />
        </ThemeModeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

function renderCustomerApp(msalInstance) {
  initializeDataverseService(msalInstance);

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeModeProvider>
          <MsalProvider instance={msalInstance}>
            <CustomerApp />
          </MsalProvider>
        </ThemeModeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

async function bootstrapCustomerApp() {
  renderBootstrapLoading();
  syncSelectedCustomerFromUrl();
  ensureCustomerSelection({ redirectIfMissing: false });

  const msalInstance = new PublicClientApplication(msalConfig);

  await msalInstance.initialize();

  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const existing = msalInstance.getAllAccounts();
      if (existing.length > 0) {
        msalInstance.setActiveAccount(existing[0]);
      }
    }
  } catch (error) {
    console.error('Login redirect failed:', error);
  }

  renderCustomerApp(msalInstance);
}

if (isPortalMode()) {
  renderPortalApp();
} else {
  bootstrapCustomerApp();
}
